<nz-result nzStatus="403" nzTitle="403" nzSubTitle="Lo sentimos, no tienes permiso para acceder a esta página. Comunícate con la Liga de Patinaje de Antioquia para obtener ayuda">
    <div nz-result-extra>
      <button nz-button (click)="logout()" nzType="primary">Volver a iniciar sesión</button>
    </div>
  </nz-result>